module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('m-panel', {
    attrs: {
      "title": "理赔流程"
    }
  }, [_c('span', {
    slot: "label"
  }, [_vm._v("(理赔材料详见"), _c('a', {
    on: {
      "click": function($event) {
        _vm.openNewWindow(_vm.lipeiliucheng.url)
      }
    }
  }, [_vm._v(_vm._s(_vm.lipeiliucheng.name))]), _vm._v(")")]), _vm._v(" "), _c('ul', {
    staticClass: "process"
  }, _vm._l((_vm.process), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('p', {
      staticClass: "title",
      style: ('background-image: url(static/common/images/process_' + (index + 1) + '.png);')
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "content",
      style: ('background-image: url(static/common/images/process_line_' + (index + 1) + '.png);'),
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43dd7218","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Process.vue
// module id = 661
// module chunks = 1